/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskCompensationHighestPaidEmplGrp
 */
export interface ExecRiskCompensationHighestPaidEmplGrp {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskCompensationHighestPaidEmplGrp
     */
    PersonNm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskCompensationHighestPaidEmplGrp
     */
    TitleTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskCompensationHighestPaidEmplGrp
     */
    AverageHoursPerWeekRt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskCompensationHighestPaidEmplGrp
     */
    CompensationAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskCompensationHighestPaidEmplGrp
     */
    EmployeeBenefitsAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskCompensationHighestPaidEmplGrp interface.
 */
export function instanceOfExecRiskCompensationHighestPaidEmplGrp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskCompensationHighestPaidEmplGrpFromJSON(json: any): ExecRiskCompensationHighestPaidEmplGrp {
    return ExecRiskCompensationHighestPaidEmplGrpFromJSONTyped(json, false);
}

export function ExecRiskCompensationHighestPaidEmplGrpFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskCompensationHighestPaidEmplGrp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'PersonNm': !exists(json, 'PersonNm') ? undefined : json['PersonNm'],
        'TitleTxt': !exists(json, 'TitleTxt') ? undefined : json['TitleTxt'],
        'AverageHoursPerWeekRt': !exists(json, 'AverageHoursPerWeekRt') ? undefined : json['AverageHoursPerWeekRt'],
        'CompensationAmt': !exists(json, 'CompensationAmt') ? undefined : json['CompensationAmt'],
        'EmployeeBenefitsAmt': !exists(json, 'EmployeeBenefitsAmt') ? undefined : json['EmployeeBenefitsAmt'],
    };
}

export function ExecRiskCompensationHighestPaidEmplGrpToJSON(value?: ExecRiskCompensationHighestPaidEmplGrp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PersonNm': value.PersonNm,
        'TitleTxt': value.TitleTxt,
        'AverageHoursPerWeekRt': value.AverageHoursPerWeekRt,
        'CompensationAmt': value.CompensationAmt,
        'EmployeeBenefitsAmt': value.EmployeeBenefitsAmt,
    };
}

